import React from 'react';

const RootsPirateShip = (props) => {
  const { radius, cells } = props;

  const base = cells[1].background;

  return (

    <svg width={`${radius * 2.30}px`} height={`${radius * 1.11}px`} x={`-${radius * 1.2}px`} y={`-${radius * 1.12}px`} viewBox="0 0 230 111" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Canvas">
        <g id="Group">
          <g><use xlinkHref="#path0_fill" transform="translate(124.917 4.28372)" fill="#DFD4C0" /></g>
          <g><use xlinkHref="#path1_fill" transform="translate(56.6071 10.0321)" fill="#DFD4C0" /></g>
          <g><use xlinkHref="#path2_fill" transform="translate(81.4877 -2.27374e-13)" fill="#DFD4C0" /></g>
        </g>
        <g><use xlinkHref="#path3_fill" transform="translate(0 93.4524)" fill={base} /></g>
        <g><use xlinkHref="#path4_fill" transform="translate(158.571 100.893)" fill={base} /></g>
        <g><use xlinkHref="#path5_fill" transform="matrix(6.12323e-17 1 -1 6.12323e-17 123 -7.88861e-31)" fill={base} /></g>
      </g>
      <defs>
        <path id="path0_fill" d="M 51.4758 53.752C 62 37.2643 62 16.4859 51.4758 -4.64527e-07L 5.47892e-07 -4.64527e-07C 9.26033 16.7993 9.26033 36.9527 5.47892e-07 53.752L 51.4758 53.752Z" />
        <path id="path1_fill" d="M 0.303411 29.9418L 27.7505 29.9418L 27.7505 25.7872L 18.9874 25.7872L 18.9874 -3.96214e-07L -5.47892e-08 -3.96214e-07L 8.09336 16.2441L 0.303411 29.9418Z" />
        <path id="path2_fill" d="M -4.10919e-07 29.9418L 31.1508 29.9418L 31.1508 -8.19753e-07L -4.10919e-07 -8.19753e-07L -4.10919e-07 29.9418ZM 7.84561 11.307C 6.72532 10.1895 6.72532 8.37905 7.84561 7.2616C 8.9659 6.14416 10.781 6.14416 11.9013 7.2616L 15.5745 10.9255L 19.2478 7.2616C 20.3681 6.14416 22.1831 6.14416 23.3034 7.2616C 24.4237 8.37905 24.4237 10.1895 23.3034 11.307L 19.6302 14.9709L 23.3034 18.6348C 24.4237 19.7523 24.4237 21.5628 23.3034 22.6802C 22.7433 23.2389 22.009 23.5183 21.2747 23.5183C 20.5404 23.5183 19.8061 23.2389 19.246 22.6802L 15.5727 19.0163L 11.8995 22.6802C 11.3393 23.2389 10.605 23.5183 9.87074 23.5183C 9.13645 23.5183 8.40216 23.2389 7.84202 22.6802C 6.72173 21.5628 6.72173 19.7523 7.84202 18.6348L 11.5153 14.9709L 7.84561 11.307Z" />
        <path id="path3_fill" d="M 0 0L 71.4286 0L 71.4286 17.2619L 0 17.2619L 0 0Z" />
        <path id="path4_fill" d="M 0 0L 71.4286 0L 71.4286 9.82143L 0 9.82143L 0 0Z" />
        <path id="path5_fill" d="M 0 0L 111 0L 111 7L 0 7L 0 0Z" />
      </defs>
    </svg>
  )
}
export default RootsPirateShip;

export function resize(props) {
  const { radius, minY, minX, maxX } = props;

  return {
    ...props,
    minY: minY + radius * 1.13,
    minX: minX + radius * .21,
    maxX: maxX + radius * .11,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/rootstech/pirate-ship.js